module.exports = __webpack_public_path__ + "img/NR.f2b259a0.png";